import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

import { VerticalDivider } from '../Divider/Divider'
import { LinkButton } from '../Button/LinkButton'

import { EmailContactFilter } from './EmailContactFilter'
import { EmailDateFilter } from './EmailDateFilter'
import { EmailFilterModal } from './EmailFilterModal'
import { EmailQuickFilter } from './EmailQuickFilters'
import { EmailFilterButtons } from './EmailFilterButtons'

import './EmailFilters.scss'

export const EmailFilters: React.FC = () => {
  return (
    <>
      <EmailFilterModal />
      <Container fluid>
        <Row className='g-3'>
          <Col>
            <EmailQuickFilter />
          </Col>
          <Col>
            <EmailContactFilter />
          </Col>
          <Col>
            <EmailDateFilter />
          </Col>
          <Col xs={'auto'}>
            <EmailFilterButtons />
          </Col>
          <Col xs={'auto'}>
            <div className='d-flex h-100 align-items-end'>
              <div className='d-flex align-items-center gap-3'>
                <VerticalDivider className='zocks-py-0.75' />
                <LinkButton variant='primary' to='/email/new' className='text-nowrap'>
                  New email
                </LinkButton>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}
